import { MainContainer } from '@app/components/Container/MainContainer';
import { ModalErrorUnathenthicated } from '@app/components/ModalErrorUnathenthicated/ModalErrorUnathenthicated';
import { Stack } from '@mui/system';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';
import { SelectedTranslate } from '../SelectedTranslate/SelectedTranslate';
import { Table } from '../Table/Table';
interface IMainProps {}

export const Main: FunctionComponent<IMainProps> = observer<FunctionComponent<IMainProps>>(function () {
    return (
        <MainContainer>
            <Stack spacing={2}>
                <SelectedTranslate />
                <Table />
                <ModalErrorUnathenthicated />
            </Stack>
        </MainContainer>
    );
});
